import Icon from '../Icon.vue'

Icon.register({
  'txt': {
    width: 21,
    height: 20,
    paths: [
      {
        d: 'M10 5V2.824L12.176 5H10zm.003-5H1a1 1 0 00-1 1v18a1 1 0 001 1h13a1 1 0 001-1v-3h-2v2H2V2h6v4a1 1 0 001 1h4v2h2V4.997L10.003 0z'
      },
      {
        d: 'M10.382 11.118v3.895H9.155v-3.895H7.93v-1.092h3.678v1.092h-1.226zM14.854 15.013l-.818-1.534-.82 1.534h-1.401l1.555-2.557-1.456-2.43h1.393l.729 1.408.728-1.407h1.393L14.7 12.456l1.555 2.557h-1.4zM18.774 11.118v3.895h-1.226v-3.895h-1.225v-1.092H20v1.092h-1.226z'
      }
    ]
  }
})
